(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2855],{

/***/ 3106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ PrintConfigContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


var PrintConfigContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isPrint: false,
    images: {
        lazyloadEnabled: true
    }
});
var PrintConfigProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrintConfigContext.Provider, {
        value: {
            isPrint: true,
            images: {
                lazyloadEnabled: false
            }
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PrintConfigProvider);


/***/ }),

/***/ 31250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ TitleH2; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/cms/Title/Title.module.scss
var Title_module = __webpack_require__(16128);
var Title_module_default = /*#__PURE__*/__webpack_require__.n(Title_module);
// EXTERNAL MODULE: ./src/themes/carreisen-ostschweiz/components/cms/TitleDecoration/index.tsx + 1 modules
var TitleDecoration = __webpack_require__(61207);
;// CONCATENATED MODULE: ./src/components/cms/Title/Title.tsx



var TitleH2 = function(param) {
    var title = param.title, subtitle = param.subtitle, _withDecoration = param.withDecoration, withDecoration = _withDecoration === void 0 ? false : _withDecoration, _mb = param.mb, mb = _mb === void 0 ? "default" : _mb, _className = param.className, className = _className === void 0 ? "" : _className, _overlap = param.overlap, overlap = _overlap === void 0 ? false : _overlap;
    var subTitleSpacing = subtitle !== undefined ? "me-3" : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-".concat(mb, " ").concat(className, " ").concat((Title_module_default()).root, " ").concat(withDecoration ? (Title_module_default()).withDecoration : ""),
        children: [
            withDecoration && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleDecoration/* default */.Z, {}),
            overlap === true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-0 ".concat((Title_module_default()).visible, " ").concat(subTitleSpacing),
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-0 ".concat((Title_module_default()).positioner, " ").concat(subTitleSpacing),
                        children: title
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "mb-0 ".concat(subTitleSpacing),
                    children: title
                })
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Title_module_default()).subTitle,
                children: subtitle
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/cms/Title/index.tsx




/***/ }),

/***/ 69894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ elements_Accordion_Accordion; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/elements/Accordion/Accordion.module.scss
var Accordion_module = __webpack_require__(96665);
var Accordion_module_default = /*#__PURE__*/__webpack_require__.n(Accordion_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Accordion.js + 4 modules
var Accordion = __webpack_require__(67356);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(48648);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/AccordionButton.js
var AccordionButton = __webpack_require__(54108);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
;// CONCATENATED MODULE: ./src/components/elements/Accordion/Accordion.tsx








function CustomToggle(param) {
    var children = param.children, eventKey = param.eventKey, trackingId = param.trackingId, initialActive = param.active;
    var ref = (0,react.useState)(initialActive), active = ref[0], setActive = ref[1];
    var decoratedOnClick = (0,AccordionButton/* useAccordionButton */.k)(eventKey, function() {
        setActive(!active);
    });
    var trackingAttributes = {};
    if (trackingId) {
        trackingAttributes = {
            "data-tr-click": "".concat(trackingId, ":").concat(active ? "open" : "close")
        };
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "button",
        className: "".concat(active && (Accordion_module_default()).active, " ").concat((Accordion_module_default()).accordionButton),
        onClick: decoratedOnClick
    }, trackingAttributes), {
        children: children
    }));
}
var Accordion_Accordion = function(param) {
    var items = param.items, _variant = param.variant, variant = _variant === void 0 ? "" : _variant, className = param.className, collapsed = param.collapsed, trackingCategoryAndObject = param.trackingCategoryAndObject;
    var getDefaultActiveKey = function(index) {
        if (collapsed === false) {
            return "".concat(index);
        }
        return items.length === 1 ? "0" : "99";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((Accordion_module_default()).root, " ").concat(className, " ").concat((Accordion_module_default())[variant]),
        children: items.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                className: (Accordion_module_default()).accordion,
                defaultActiveKey: getDefaultActiveKey(index),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                    className: (Accordion_module_default()).accordionItem,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Header */.Z.Header, {
                            className: (Accordion_module_default()).accordionHeader,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomToggle, {
                                eventKey: "".concat(index),
                                trackingId: trackingCategoryAndObject,
                                active: index == 0 && getDefaultActiveKey(index) == "0",
                                children: item.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Collapse */.Z.Collapse, {
                            eventKey: "".concat(index),
                            children: typeof item.content === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                className: (Accordion_module_default()).cardBody,
                                dangerouslySetInnerHTML: {
                                    __html: item.content
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                className: "".concat((Accordion_module_default()).cardBody, " display-linebreak"),
                                children: item.content
                            })
                        })
                    ]
                })
            }, index);
        })
    });
};
/* harmony default export */ var elements_Accordion_Accordion = (Accordion_Accordion);

;// CONCATENATED MODULE: ./src/components/elements/Accordion/index.ts



/***/ }),

/***/ 66913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ImageGradientOverlay_ImageGradientOverlay; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(46819);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/elements/ImageGradientOverlay/ImageGradientOverlay.module.scss
var ImageGradientOverlay_module = __webpack_require__(97227);
var ImageGradientOverlay_module_default = /*#__PURE__*/__webpack_require__.n(ImageGradientOverlay_module);
;// CONCATENATED MODULE: ./src/components/elements/ImageGradientOverlay/ImageGradientOverlay.tsx



var ImageGradientOverlay = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ImageGradientOverlay_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ImageGradientOverlay_module_default()).top
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ImageGradientOverlay_module_default()).bottom
            })
        ]
    });
};
/* harmony default export */ var ImageGradientOverlay_ImageGradientOverlay = (ImageGradientOverlay);

;// CONCATENATED MODULE: ./src/components/elements/ImageGradientOverlay/index.tsx



/***/ }),

/***/ 75150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CustomButton_CustomButton; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/themes/carreisen-ostschweiz/components/elements/buttons/CustomButton/CustomButton.module.scss
var CustomButton_module = __webpack_require__(7146);
var CustomButton_module_default = /*#__PURE__*/__webpack_require__.n(CustomButton_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.1_@babel+core@7.29.7_@types+react-dom@18.0.6_@types+react@18.0.20_babel-plugi_4de291d6de77943be594741332b7d5bc/node_modules/next/link.js
var next_link = __webpack_require__(64127);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/elements/buttons/CustomButton/CustomButton.tsx



var CustomButton = function(param) {
    var label = param.label, href = param.href, _targetBlank = param.targetBlank, targetBlank = _targetBlank === void 0 ? false : _targetBlank, className = param.className;
    var classString = (CustomButton_module_default()).root;
    if (className !== undefined) {
        classString += " " + className;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "clearfix ".concat(classString),
        children: href !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (CustomButton_module_default()).ribbon,
                target: targetBlank ? "_blank" : undefined,
                dangerouslySetInnerHTML: {
                    __html: label
                }
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (CustomButton_module_default()).ribbon,
            dangerouslySetInnerHTML: {
                __html: label
            }
        })
    });
};
/* harmony default export */ var CustomButton_CustomButton = (CustomButton);

;// CONCATENATED MODULE: ./src/components/elements/buttons/CustomButton/index.tsx



/***/ }),

/***/ 42500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CloudinaryImage_CloudinaryImage; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(88149);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/CloudinaryImage.module.scss
var CloudinaryImage_module = __webpack_require__(47464);
var CloudinaryImage_module_default = /*#__PURE__*/__webpack_require__.n(CloudinaryImage_module);
// EXTERNAL MODULE: ./src/integrations/cloudinary/cloudinaryUrlGenerator.ts
var cloudinaryUrlGenerator = __webpack_require__(49077);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+react@1.5.0_@cloudinary+url-gen@1.8.6_@types+react@18.0.20_react@18.2.0/node_modules/@cloudinary/react/index.js
var react = __webpack_require__(90330);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+transformation-builder-sdk@1.21.2/node_modules/@cloudinary/transformation-builder-sdk/actions/resize.js + 38 modules
var resize = __webpack_require__(66469);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+url-gen@1.8.6/node_modules/@cloudinary/url-gen/assets/CloudinaryVideo.js + 1 modules
var CloudinaryVideo = __webpack_require__(54074);
// EXTERNAL MODULE: ../../node_modules/.pnpm/use-device-pixel-ratio@1.1.2_react@18.2.0/node_modules/use-device-pixel-ratio/dist/index.module.js
var index_module = __webpack_require__(16867);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+transformation-builder-sdk@1.21.2/node_modules/@cloudinary/transformation-builder-sdk/actions/delivery.js + 5 modules
var delivery = __webpack_require__(94134);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var node_modules_react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/app/providers/PrintConfigProvider.tsx
var PrintConfigProvider = __webpack_require__(3106);
;// CONCATENATED MODULE: ./src/components/elements/media/CloudinaryImage/CloudinaryImage.tsx












var CloudinaryImage = function(param) {
    var image = param.image, tmp = param.lazyload, lazyloadOption = tmp === void 0 ? true : tmp, tmp1 = param.responsive, responsiveOption = tmp1 === void 0 ? true : tmp1, tmp2 = param.placeholder, placeholderOption = tmp2 === void 0 ? false : tmp2, width = param.width, height = param.height, _sizeAttributes = param.sizeAttributes, sizeAttributes = _sizeAttributes === void 0 ? false : _sizeAttributes, tmp3 = param.dpr, dprOption = tmp3 === void 0 ? true : tmp3, _cropType = param.cropType, cropType = _cropType === void 0 ? "fill" : _cropType, aspectRatio = param.aspectRatio, titleDefault = param.titleDefault, altDefault = param.altDefault, _className = param.className, className = _className === void 0 ? "" : _className, style = param.style, _placeholderClassName = param.placeholderClassName, placeholderClassName = _placeholderClassName === void 0 ? "" : _placeholderClassName, cld = param.cld, trackingStringClick = param.trackingStringClick, trackingStringDblClick = param.trackingStringDblClick;
    var deviceDpr = (0,index_module/* useDevicePixelRatio */.j)();
    var printConfig = (0,node_modules_react.useContext)(PrintConfigProvider/* PrintConfigContext */.E);
    lazyloadOption = printConfig.images.lazyloadEnabled === false ? false : lazyloadOption;
    if (!(image === null || image === void 0 ? void 0 : image.publicId)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((CloudinaryImage_module_default()).placeholder, " ").concat(placeholderClassName)
        });
    }
    if (!cld) {
        cld = cloudinaryUrlGenerator/* default */.Z;
    }
    var mediaFile = image.resourceType === "video" ? cld.video(image.publicId) : cld.image(image.publicId);
    var options = {};
    if (aspectRatio) {
        options.aspect_ratio = aspectRatio;
    }
    if (image.resourceType !== "video") {
        mediaFile.format("auto").quality("auto");
    } else {
        mediaFile.format("auto").quality(70);
    }
    if (dprOption && image.resourceType !== "video") {
        var imageDpr = Number.isInteger(dprOption) ? dprOption : deviceDpr;
        mediaFile.delivery((0,delivery/* dpr */.uN)(imageDpr + ".0"));
    } else {
    // omit dpr for videos
    //mediaFile.delivery(dpr('1.0'))
    }
    var cropSettings;
    switch(cropType){
        case "fill":
            cropSettings = (0,resize/* fill */.hl)();
            break;
        case "scale":
            cropSettings = (0,resize/* scale */.bA)();
            break;
    }
    if (!responsiveOption) {
        if (width) {
            cropSettings.width(width);
        }
        if (height) {
            cropSettings.height(height);
        }
    }
    if (aspectRatio) {
        cropSettings.aspectRatio(aspectRatio);
    }
    if (cropType === "fill" && (aspectRatio || width || height)) {
        if ((0,_instanceof/* default */.Z)(mediaFile, CloudinaryVideo/* CloudinaryVideo */._)) {
            // Videos cannot handle gravity('auto') on mobile
            // @ts-ignore
            cropSettings.gravity("center");
        } else {
            // @ts-ignore
            cropSettings.gravity("auto");
        }
    }
    mediaFile.resize(cropSettings);
    // see: https://cloudinary.com/documentation/react_image_transformations#plugins
    var plugins = [];
    // placeholder
    // Note: Not using recommended plugin order, as this loads the display image before placeholder image | see: https://cloudinary.com/documentation/react_image_transformations#plugin_order
    if (placeholderOption || lazyloadOption === "placeholder") {
        plugins.push((0,react/* placeholder */.W$)({
            mode: "blur"
        })) // see: https://cloudinary.com/documentation/react_image_transformations#image_placeholders
        ;
    }
    // lazyload
    if (lazyloadOption) {
        plugins.push((0,react/* lazyload */.mA)());
    }
    // responsive breakpoints
    if (responsiveOption) {
        plugins.push((0,react/* responsive */.jW)({
            steps: 200
        }));
    }
    var getSizeAttributes = function() {
        if (sizeAttributes) {
            // custom sizes
            if (width && height) {
                return {
                    width: width,
                    height: height
                };
            }
            // dynamic sizes by aspect ratio
            if (aspectRatio) {
                if (width) {
                    return {
                        width: width,
                        height: width / aspectRatio
                    };
                }
                if (height) {
                    return {
                        width: height * aspectRatio,
                        height: height
                    };
                }
            }
            // intrinsic sizes
            return {
                width: image.width,
                height: image.height
            };
        }
        return {};
    };
    var getTrackingAttributes = function() {
        var trackingAttributes = {};
        // if "trackingStringClick" is set, build "data-tr-click={trackingStringClick}"
        if (trackingStringClick) {
            trackingAttributes["data-tr-click"] = trackingStringClick;
        }
        // if "trackingStringDblClick" is set, build "data-tr-click={trackingStringDblClick}"
        if (trackingStringDblClick) {
            trackingAttributes["data-tr-dblclick"] = trackingStringDblClick;
        }
        return trackingAttributes;
    };
    return function() {
        if ((0,_instanceof/* default */.Z)(mediaFile, CloudinaryVideo/* CloudinaryVideo */._)) {
            var posterImage = mediaFile.addTransformation("so_0").toURL();
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react/* AdvancedVideo */.xl, {
                cldVid: mediaFile,
                poster: posterImage,
                plugins: plugins,
                autoPlay: true,
                playsInline: true,
                loop: true,
                muted: true
            });
        }
        var _title, ref, _description, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react/* AdvancedImage */.pw, (0,_object_spread/* default */.Z)({
            className: className,
            cldImg: mediaFile,
            plugins: plugins,
            title: (ref = (_title = image.title) !== null && _title !== void 0 ? _title : titleDefault) !== null && ref !== void 0 ? ref : "",
            alt: (ref1 = (_description = image.description) !== null && _description !== void 0 ? _description : altDefault) !== null && ref1 !== void 0 ? ref1 : "",
            loading: lazyloadOption === true ? "lazy" : "auto",
            style: style !== null && style !== void 0 ? style : {}
        }, getSizeAttributes(), getTrackingAttributes()));
    }();
};
/* harmony default export */ var CloudinaryImage_CloudinaryImage = (CloudinaryImage);

;// CONCATENATED MODULE: ./src/components/elements/media/CloudinaryImage/index.ts



/***/ }),

/***/ 5183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93089);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var _components_elements_media_CloudinaryImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42500);
/* harmony import */ var _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73974);





var cloudinaryUrlGenerator = new _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_2__/* .Cloudinary */ .r({
    cloud: {
        cloudName: "difp9jq5j"
    },
    url: {
        analytics: false
    }
});
var ThemeImage = function(props) {
    var cropType = props.cropType;
    if (!props.cropType) {
        cropType = "scale";
    }
    var responsive = props.responsive !== undefined ? props.responsive : false;
    var theme = props.theme ? props.theme : "carreisen-ostschweiz";
    var image = props.image ? props.image : {
        publicId: "themes/".concat(theme, "/").concat(props.src),
        title: props.title,
        description: props.alt
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_media_CloudinaryImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        image: image,
        responsive: responsive,
        cropType: cropType,
        dpr: props.dpr !== undefined ? props.dpr : false,
        cld: cloudinaryUrlGenerator,
        style: props.style ? props.style : {},
        sizeAttributes: true
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ThemeImage);


/***/ }),

/***/ 13652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SeoHeader_SeoHeader; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.1_@babel+core@7.29.7_@types+react-dom@18.0.6_@types+react@18.0.20_babel-plugi_4de291d6de77943be594741332b7d5bc/node_modules/next/head.js
var head = __webpack_require__(57966);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.1_@babel+core@7.29.7_@types+react-dom@18.0.6_@types+react@18.0.20_babel-plugi_4de291d6de77943be594741332b7d5bc/node_modules/next/router.js
var next_router = __webpack_require__(24826);
// EXTERNAL MODULE: ./src/integrations/cloudinary/cloudinaryUrlGenerator.ts
var cloudinaryUrlGenerator = __webpack_require__(49077);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+transformation-builder-sdk@1.21.2/node_modules/@cloudinary/transformation-builder-sdk/actions/resize.js + 38 modules
var resize = __webpack_require__(66469);
;// CONCATENATED MODULE: ./src/components/elements/seo/SeoHeader/SeoHeader.tsx





var SeoHeader = function(param) {
    var seoSettings = param.seoSettings, _noIndex = param.noIndex, noIndex = _noIndex === void 0 ? false : _noIndex;
    // build canonicalUrl
    var router = (0,next_router.useRouter)();
    var canonicalUrl = ("https://www.carreisen-ostschweiz.ch" + (router.locale ? "/" + router.locale : "") + (router.route === "/404" || router.route === "/500" ? router.route : router.asPath !== "/" ? router.asPath : "")).split("?")[0];
    // build optimized image url
    var cld = cloudinaryUrlGenerator/* default */.Z;
    var ogImage = cld.image(seoSettings.ogImage.publicId);
    var cropSettings = (0,resize/* fill */.hl)();
    cropSettings.width(1200);
    cropSettings.height(630);
    cropSettings.gravity("auto");
    ogImage.resize(cropSettings).format("auto").quality("auto");
    var ogImageUrl = ogImage.toURL();
    var twitterImage = cld.image(seoSettings.ogImage.publicId);
    cropSettings.width(1200);
    cropSettings.height(600);
    cropSettings.gravity("auto");
    twitterImage.resize(cropSettings).format("auto").quality("auto");
    var twitterImageUrl = twitterImage.toURL();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: seoSettings.metaTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: seoSettings.metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: seoSettings.ogTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: seoSettings.ogDescription
            }),
            seoSettings.ogImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: ogImageUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: seoSettings.ogTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: seoSettings.ogDescription
            }),
            seoSettings.ogImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: twitterImageUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            noIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noindex"
            })
        ]
    });
};
/* harmony default export */ var SeoHeader_SeoHeader = (SeoHeader);

;// CONCATENATED MODULE: ./src/components/elements/seo/SeoHeader/index.ts



/***/ }),

/***/ 72026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SliderWithDots_SliderWithDots; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(11296);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/embla-carousel-react@7.0.3_react@18.2.0/node_modules/embla-carousel-react/embla-carousel-react.umd.js
var embla_carousel_react_umd = __webpack_require__(73329);
var embla_carousel_react_umd_default = /*#__PURE__*/__webpack_require__.n(embla_carousel_react_umd);
// EXTERNAL MODULE: ../../node_modules/.pnpm/embla-carousel-autoplay@7.0.3_embla-carousel@7.0.3/node_modules/embla-carousel-autoplay/embla-carousel-autoplay.umd.js
var embla_carousel_autoplay_umd = __webpack_require__(13452);
var embla_carousel_autoplay_umd_default = /*#__PURE__*/__webpack_require__.n(embla_carousel_autoplay_umd);
// EXTERNAL MODULE: ./src/components/elements/sliders/SliderWithDots/EmblaCarousel.module.scss
var EmblaCarousel_module = __webpack_require__(61216);
var EmblaCarousel_module_default = /*#__PURE__*/__webpack_require__.n(EmblaCarousel_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-in-viewport@1.0.0-alpha.28_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-in-viewport/dist/es/index.js
var es = __webpack_require__(89650);
// EXTERNAL MODULE: ./src/components/elements/sliders/common/DotButton/index.tsx + 1 modules
var DotButton = __webpack_require__(26149);
// EXTERNAL MODULE: ./src/components/elements/sliders/common/PrevButton/PrevButton.module.scss
var PrevButton_module = __webpack_require__(61148);
var PrevButton_module_default = /*#__PURE__*/__webpack_require__.n(PrevButton_module);
;// CONCATENATED MODULE: ./src/components/elements/sliders/common/PrevButton/PrevButton.tsx


var PrevButton = function(param) {
    var disabled = param.disabled, onClick = param.onClick, trackingString = param.trackingString;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "".concat((PrevButton_module_default()).embla__button, " ").concat((PrevButton_module_default()).embla__buttonPrev),
        onClick: onClick,
        disabled: disabled,
        "aria-label": "Slider navigation previous",
        "data-tr-click": trackingString,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            className: (PrevButton_module_default()).embla__button__svg,
            viewBox: "137.718 -1.001 366.563 644",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M428.36 12.5c16.67-16.67 43.76-16.67 60.42 0 16.67 16.67 16.67 43.76 0 60.42L241.7 320c148.25 148.24 230.61 230.6 247.08 247.08 16.67 16.66 16.67 43.75 0 60.42-16.67 16.66-43.76 16.67-60.42 0-27.72-27.71-249.45-249.37-277.16-277.08a42.308 42.308 0 0 1-12.48-30.34c0-11.1 4.1-22.05 12.48-30.42C206.63 234.23 400.64 40.21 428.36 12.5z"
            })
        })
    });
};
/* harmony default export */ var PrevButton_PrevButton = (PrevButton);

;// CONCATENATED MODULE: ./src/components/elements/sliders/common/PrevButton/index.tsx


// EXTERNAL MODULE: ./src/components/elements/sliders/common/NextButton/NextButton.module.scss
var NextButton_module = __webpack_require__(50500);
var NextButton_module_default = /*#__PURE__*/__webpack_require__.n(NextButton_module);
;// CONCATENATED MODULE: ./src/components/elements/sliders/common/NextButton/NextButton.tsx


var NextButton = function(param) {
    var disabled = param.disabled, onClick = param.onClick, trackingString = param.trackingString;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "".concat((NextButton_module_default()).embla__button, " ").concat((NextButton_module_default()).embla__buttonNext),
        onClick: onClick,
        disabled: disabled,
        "aria-label": "Slider navigation next",
        "data-tr-click": trackingString,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            className: (NextButton_module_default()).embla__button__svg,
            viewBox: "0 0 238.003 238.003",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M181.776 107.719L78.705 4.648c-6.198-6.198-16.273-6.198-22.47 0s-6.198 16.273 0 22.47l91.883 91.883-91.883 91.883c-6.198 6.198-6.198 16.273 0 22.47s16.273 6.198 22.47 0l103.071-103.039a15.741 15.741 0 0 0 4.64-11.283c0-4.13-1.526-8.199-4.64-11.313z"
            })
        })
    });
};
/* harmony default export */ var NextButton_NextButton = (NextButton);

;// CONCATENATED MODULE: ./src/components/elements/sliders/common/NextButton/index.tsx


;// CONCATENATED MODULE: ./src/components/elements/sliders/SliderWithDots/SliderWithDots.tsx











var SliderWithDots = function(param) {
    var slides = param.slides, _options = param.options, options = _options === void 0 ? {} : _options, _arrows = param.arrows, arrows = _arrows === void 0 ? false : _arrows, _dotsPosition = param.dotsPosition, dotsPosition = _dotsPosition === void 0 ? "below" : _dotsPosition, _autoplay = param.autoplay, autoplay = _autoplay === void 0 ? false : _autoplay, _ssr = param.ssr, ssr = _ssr === void 0 ? false : _ssr, trackingStringPrefix = param.trackingStringPrefix;
    var defaultOptions = {
        loop: true,
        skipSnaps: true
    };
    options = (0,_object_spread/* default */.Z)({}, defaultOptions, options);
    var dotTheme = dotsPosition === "below" ? "dark" : "light";
    var ref = (0,react.useState)(ssr), domLoaded = ref[0], setDomLoaded = ref[1];
    //autoplay
    var plugins = [];
    if (autoplay) {
        var autoplayRoot = function(emblaRoot) {
            return emblaRoot.parentElement // Root node
            ;
        };
        var autoplayPlugin = embla_carousel_autoplay_umd_default()({
            delay: typeof autoplay === "number" ? autoplay : 5000,
            rootNode: autoplayRoot
        });
        plugins.push(autoplayPlugin);
    }
    var ref1 = (0,_sliced_to_array/* default */.Z)(embla_carousel_react_umd_default()(options, plugins), 2), viewportRef = ref1[0], embla = ref1[1];
    var ref2 = (0,react.useState)(0), selectedIndex = ref2[0], setSelectedIndex = ref2[1];
    var ref3 = (0,react.useState)([]), scrollSnaps = ref3[0], setScrollSnaps = ref3[1];
    var ref4 = (0,react.useState)(true), prevBtnDisabled = ref4[0], setPrevBtnDisabled = ref4[1];
    var ref5 = (0,react.useState)(true), nextBtnDisabled = ref5[0], setNextBtnDisabled = ref5[1];
    var scrollTo = (0,react.useCallback)(function(index) {
        return embla && embla.scrollTo(index);
    }, [
        embla
    ]);
    var scrollPrev = (0,react.useCallback)(function() {
        return embla && embla.scrollPrev();
    }, [
        embla
    ]);
    var scrollNext = (0,react.useCallback)(function() {
        return embla && embla.scrollNext();
    }, [
        embla
    ]);
    var onSelect = (0,react.useCallback)(function() {
        if (!embla) return;
        setSelectedIndex(embla.selectedScrollSnap());
        setPrevBtnDisabled(!embla.canScrollPrev());
        setNextBtnDisabled(!embla.canScrollNext());
    }, [
        embla,
        setSelectedIndex
    ]);
    // rerender for correct dots (lazy loaded images)
    var myRef = /*#__PURE__*/ react.createRef();
    var inViewport = (0,es/* useInViewport */.NM)(myRef, options, {
        disconnectOnLeave: false
    }).inViewport;
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            if (!embla) return;
            if (inViewport) {
                embla.reInit();
                setScrollSnaps(embla.scrollSnapList());
            }
        }, 500);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        embla,
        inViewport
    ]);
    (0,react.useEffect)(function() {
        setDomLoaded(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (!embla) return;
        onSelect();
        setScrollSnaps(embla.scrollSnapList());
        embla.on("select", onSelect);
    }, [
        embla,
        setScrollSnaps,
        onSelect
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: domLoaded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (EmblaCarousel_module_default()).embla,
                    ref: myRef,
                    "data-tr-view": "".concat(trackingStringPrefix, ":view"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (EmblaCarousel_module_default()).embla__viewport,
                            ref: viewportRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (EmblaCarousel_module_default()).embla__container,
                                children: slides.map(function(slide, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                        children: slide
                                    }, index);
                                })
                            })
                        }),
                        arrows && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (EmblaCarousel_module_default()).embla__buttons,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevButton_PrevButton, {
                                    onClick: scrollPrev,
                                    disabled: prevBtnDisabled,
                                    trackingString: "".concat(trackingStringPrefix, "_arrow_nav_prev:click")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton_NextButton, {
                                    onClick: scrollNext,
                                    disabled: nextBtnDisabled,
                                    trackingString: "".concat(trackingStringPrefix, "_arrow_nav_next:click")
                                })
                            ]
                        })
                    ]
                }),
                dotsPosition !== "off" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (EmblaCarousel_module_default()).embla__dots + " " + (EmblaCarousel_module_default())[dotsPosition],
                    children: scrollSnaps.map(function(slide, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DotButton/* default */.Z, {
                            selected: index === selectedIndex,
                            theme: dotTheme,
                            onClick: function() {
                                return scrollTo(index);
                            },
                            trackingString: "".concat(trackingStringPrefix, "_dot_nav:click")
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var SliderWithDots_SliderWithDots = (SliderWithDots);

;// CONCATENATED MODULE: ./src/components/elements/sliders/SliderWithDots/index.tsx



/***/ }),

/***/ 26149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ DotButton_DotButton; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/elements/sliders/common/DotButton/DotButton.module.scss
var DotButton_module = __webpack_require__(88555);
var DotButton_module_default = /*#__PURE__*/__webpack_require__.n(DotButton_module);
;// CONCATENATED MODULE: ./src/components/elements/sliders/common/DotButton/DotButton.tsx


var DotButton = function(param) {
    var selected = param.selected, onClick = param.onClick, theme = param.theme, trackingString = param.trackingString;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: (DotButton_module_default()).embla__dot + " " + (DotButton_module_default())[theme] + " ".concat(selected ? (DotButton_module_default()).isSelected : ""),
        type: "button",
        onClick: onClick,
        "aria-label": "Slider navigation",
        "data-tr-click": trackingString
    });
};
/* harmony default export */ var DotButton_DotButton = (DotButton);

;// CONCATENATED MODULE: ./src/components/elements/sliders/common/DotButton/index.tsx



/***/ }),

/***/ 54872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TextWithIconBlock_TextWithIconBlock; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/TextWithIconBlock/TextWithIconBlock.module.scss
var TextWithIconBlock_module = __webpack_require__(82411);
var TextWithIconBlock_module_default = /*#__PURE__*/__webpack_require__.n(TextWithIconBlock_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(73117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(35363);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(42500);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TextWithIconBlock/TextWithIconBlock.tsx




var TextWithIconBlock = function(param) {
    var _title = param.title, title = _title === void 0 ? "" : _title, _text = param.text, text = _text === void 0 ? "" : _text, image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
        className: (TextWithIconBlock_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: 12,
                sm: "auto",
                lg: 12,
                xl: "auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((TextWithIconBlock_module_default()).iconWrap),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                        image: image,
                        altDefault: "icon",
                        width: 110,
                        height: 110,
                        responsive: false,
                        sizeAttributes: true,
                        aspectRatio: 1,
                        placeholderClassName: "position-absolute"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                className: (TextWithIconBlock_module_default()).content,
                children: [
                    title !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TextWithIconBlock_module_default()).cardTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: text
                        },
                        className: "display-linebreak"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TextWithIconBlock_TextWithIconBlock = (TextWithIconBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TextWithIconBlock/index.ts



/***/ }),

/***/ 38975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TextWithImageSlider_TextWithImageSlider; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(11296);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/embla-carousel-react@7.0.3_react@18.2.0/node_modules/embla-carousel-react/embla-carousel-react.umd.js
var embla_carousel_react_umd = __webpack_require__(73329);
var embla_carousel_react_umd_default = /*#__PURE__*/__webpack_require__.n(embla_carousel_react_umd);
// EXTERNAL MODULE: ../../node_modules/.pnpm/embla-carousel-autoplay@7.0.3_embla-carousel@7.0.3/node_modules/embla-carousel-autoplay/embla-carousel-autoplay.umd.js
var embla_carousel_autoplay_umd = __webpack_require__(13452);
var embla_carousel_autoplay_umd_default = /*#__PURE__*/__webpack_require__.n(embla_carousel_autoplay_umd);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/TextWithImageBlock/TextWithImageSlider/TextWithImageSlider.module.scss
var TextWithImageSlider_module = __webpack_require__(56513);
var TextWithImageSlider_module_default = /*#__PURE__*/__webpack_require__.n(TextWithImageSlider_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-in-viewport@1.0.0-alpha.28_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-in-viewport/dist/es/index.js
var es = __webpack_require__(89650);
// EXTERNAL MODULE: ./src/components/elements/sliders/common/DotButton/index.tsx + 1 modules
var DotButton = __webpack_require__(26149);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(42500);
// EXTERNAL MODULE: ./src/components/models/media/GalleryLightBox/index.ts + 1 modules
var GalleryLightBox = __webpack_require__(41292);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TextWithImageBlock/TextWithImageSlider/TextWithImageSlider.tsx










var TextWithImageSlider = function(param) {
    var gallery = param.gallery, _fixedAspectRatio = param.fixedAspectRatio, fixedAspectRatio = _fixedAspectRatio === void 0 ? false : _fixedAspectRatio;
    /** SLIDES **/ var ref = (0,react.useState)(false), lightboxOpen = ref[0], setLightboxOpen = ref[1];
    var ref1 = (0,react.useState)(), lightboxCurrentSlide = ref1[0], setLightboxCurrentSlide = ref1[1];
    var handleLightbox = function(event, index) {
        if (event.detail === 2) {
            setLightboxCurrentSlide(index);
            setLightboxOpen(!lightboxOpen);
        }
    };
    var getSlides = function(images) {
        var slides = [];
        images.map(function(image, index) {
            var slide = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TextWithImageSlider_module_default()).embla__slide,
                onClick: function(event) {
                    return handleLightbox(event, index);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "box-ratio-16-9",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "box-ratio-inner",
                        children: fixedAspectRatio ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                            image: image,
                            width: 704,
                            sizeAttributes: true,
                            aspectRatio: 1.777,
                            responsive: false,
                            className: "card-img ".concat((TextWithImageSlider_module_default()).img, " ").concat((TextWithImageSlider_module_default()).wide)
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                                    image: image,
                                    width: 704,
                                    sizeAttributes: true,
                                    aspectRatio: 1.777,
                                    responsive: false,
                                    className: "card-img d-lg-none ".concat((TextWithImageSlider_module_default()).img)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                                    image: image,
                                    width: 704,
                                    aspectRatio: 0.8,
                                    sizeAttributes: true,
                                    responsive: false,
                                    className: "card-img d-none d-lg-block d-xl-none ".concat((TextWithImageSlider_module_default()).img)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                                    image: image,
                                    width: 704,
                                    aspectRatio: 1.5,
                                    sizeAttributes: true,
                                    responsive: false,
                                    className: "card-img d-none d-xl-block ".concat((TextWithImageSlider_module_default()).img)
                                })
                            ]
                        })
                    })
                })
            }, index);
            slides.push(slide);
        });
        return slides;
    };
    /** EMBLA **/ var options = {
        loop: true,
        skipSnaps: true
    };
    var dotTheme = "light";
    //autoplay
    var plugins = [];
    var autoplayRoot = function(emblaRoot) {
        return emblaRoot.parentElement // Root node
        ;
    };
    var autoplayPlugin = embla_carousel_autoplay_umd_default()({
        delay: 5000,
        rootNode: autoplayRoot
    });
    plugins.push(autoplayPlugin);
    var ref2 = (0,_sliced_to_array/* default */.Z)(embla_carousel_react_umd_default()(options, plugins), 2), emblaRef = ref2[0], embla = ref2[1];
    var ref3 = (0,react.useState)(0), selectedIndex = ref3[0], setSelectedIndex = ref3[1];
    var ref4 = (0,react.useState)([]), scrollSnaps = ref4[0], setScrollSnaps = ref4[1];
    var scrollTo = (0,react.useCallback)(function(index) {
        return embla && embla.scrollTo(index);
    }, [
        embla
    ]);
    var onSelect = (0,react.useCallback)(function() {
        if (!embla) return;
        setSelectedIndex(embla.selectedScrollSnap());
    }, [
        embla,
        setSelectedIndex
    ]);
    // rerender for correct dots (lazy loaded images)
    var myRef = /*#__PURE__*/ react.createRef();
    var inViewport = (0,es/* useInViewport */.NM)(myRef, options, {
        disconnectOnLeave: false
    }).inViewport;
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            if (!embla) return;
            if (inViewport) {
                embla.reInit();
                setScrollSnaps(embla.scrollSnapList());
            }
        }, 500);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        embla,
        inViewport
    ]);
    (0,react.useEffect)(function() {
        if (!embla) return;
        onSelect();
        setScrollSnaps(embla.scrollSnapList());
        embla.on("select", onSelect);
    }, [
        embla,
        setScrollSnaps,
        onSelect
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (TextWithImageSlider_module_default()).root,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((TextWithImageSlider_module_default()).embla),
                    ref: emblaRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TextWithImageSlider_module_default()).embla__container,
                        children: getSlides(gallery.images).map(function(slide) {
                            return slide;
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TextWithImageSlider_module_default()).embla__dots + " " + (TextWithImageSlider_module_default()).bottom,
                    children: scrollSnaps.map(function(slide, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DotButton/* default */.Z, {
                            selected: index === selectedIndex,
                            theme: dotTheme,
                            onClick: function() {
                                return scrollTo(index);
                            }
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryLightBox/* default */.Z, {
                    images: gallery.images,
                    open: lightboxOpen,
                    currentSlideIndex: lightboxCurrentSlide
                })
            ]
        })
    });
};
/* harmony default export */ var TextWithImageSlider_TextWithImageSlider = (TextWithImageSlider);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TextWithImageBlock/TextWithImageSlider/index.tsx



/***/ }),

/***/ 41292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GalleryLightBox_GalleryLightBox; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/fslightbox-react@file+apps+frontend+src+lib+external+fslightbox-react-pro-1.8.1.tgz_pro_4e7ae74bdfb60557844300a3f7fb97e9/node_modules/fslightbox-react/index.js
var fslightbox_react = __webpack_require__(87623);
var fslightbox_react_default = /*#__PURE__*/__webpack_require__.n(fslightbox_react);
// EXTERNAL MODULE: ./src/integrations/cloudinary/cloudinaryUrlGenerator.ts
var cloudinaryUrlGenerator = __webpack_require__(49077);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@cloudinary+transformation-builder-sdk@1.21.2/node_modules/@cloudinary/transformation-builder-sdk/actions/resize.js + 38 modules
var resize = __webpack_require__(66469);
;// CONCATENATED MODULE: ./src/components/models/media/GalleryLightBox/GalleryLightBox.tsx





var cld = cloudinaryUrlGenerator/* default */.Z;
var GalleryLightBox = function(param) {
    var images = param.images, _open = param.open, open = _open === void 0 ? false : _open, _currentSlideIndex = param.currentSlideIndex, currentSlideIndex = _currentSlideIndex === void 0 ? 0 : _currentSlideIndex;
    var ref = (0,react.useState)(open), toggler = ref[0], setToggler = ref[1];
    var ref1 = (0,react.useState)(currentSlideIndex), slide = ref1[0], setSlide = ref1[1];
    (0,react.useEffect)(function() {
        if (open != toggler) {
            setToggler(!toggler);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    (0,react.useEffect)(function() {
        if (Number.isInteger(currentSlideIndex)) {
            setSlide(currentSlideIndex);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentSlideIndex
    ]);
    var lightboxImages = images.map(function(image) {
        var myImage = cld.image(image.publicId);
        myImage.format("auto").quality("auto");
        myImage.resize((0,resize/* limitFill */.MI)().height(1080));
        return myImage.toURL();
    });
    var lightboxCaptions = images.map(function(image) {
        return image.caption ? image.caption : "";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((fslightbox_react_default()), {
            toggler: toggler,
            sources: lightboxImages,
            captions: lightboxCaptions,
            slide: slide + 1
        })
    });
};
/* harmony default export */ var GalleryLightBox_GalleryLightBox = (GalleryLightBox);

;// CONCATENATED MODULE: ./src/components/models/media/GalleryLightBox/index.ts



/***/ }),

/***/ 85302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GallerySlider_GallerySlider; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/models/media/GallerySlider/GallerySlider.module.scss
var GallerySlider_module = __webpack_require__(13333);
var GallerySlider_module_default = /*#__PURE__*/__webpack_require__.n(GallerySlider_module);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(42500);
// EXTERNAL MODULE: ./src/components/elements/sliders/SliderWithDots/index.tsx + 5 modules
var SliderWithDots = __webpack_require__(72026);
// EXTERNAL MODULE: ./src/components/models/media/GalleryLightBox/index.ts + 1 modules
var GalleryLightBox = __webpack_require__(41292);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.10.6_@mui+material@5.10.6_@emotion+react@11.10.4_@babel+core@7.29_4256a746ae3e444242b884c9f3aaf870/node_modules/@mui/icons-material/Fullscreen.js
var Fullscreen = __webpack_require__(48828);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.10.6_@emotion+react@11.10.4_@babel+core@7.29.7_@types+react@18.0.20_rea_cdb505b0d50985fd15656eb0e46c7a57/node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(12728);
;// CONCATENATED MODULE: ./src/components/models/media/GallerySlider/GallerySlider.tsx








var GallerySlider = function(param) {
    var gallery = param.gallery, sliderDotsPosition = param.sliderDotsPosition, trackingStringPrefix = param.trackingStringPrefix, _showArrows = param.showArrows, showArrows = _showArrows === void 0 ? true : _showArrows, _showLightbox = param.showLightbox, showLightbox = _showLightbox === void 0 ? true : _showLightbox, _autoplay = param.autoplay, autoplay = _autoplay === void 0 ? true : _autoplay, _size = param.size, size = _size === void 0 ? "default" : _size;
    var sliderOptions = {
        loop: true,
        skipSnaps: true,
        containScroll: "trimSnaps"
    };
    var ref = (0,react.useState)(false), lightboxOpen = ref[0], setLightboxOpen = ref[1];
    var ref1 = (0,react.useState)(), lightboxCurrentSlide = ref1[0], setLightboxCurrentSlide = ref1[1];
    var handleLightboxDoubleClick = function(event, index) {
        if (!showLightbox) return;
        if (event.detail === 2) {
            setLightboxCurrentSlide(index);
            setLightboxOpen(!lightboxOpen);
        }
    };
    var handleLightboxSingleClick = function(event, index) {
        if (!showLightbox) return;
        if (event.detail === 1) {
            setLightboxCurrentSlide(index);
            setLightboxOpen(!lightboxOpen);
        }
    };
    var getSlides = function(images) {
        var slides = [];
        images.map(function(image, index) {
            var slide = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (GallerySlider_module_default()).slideWrap,
                "data-tr-view": "".concat(trackingStringPrefix, "_image:view"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: size === "default" ? (GallerySlider_module_default()).slideInner : (GallerySlider_module_default()).slideInnerSmall,
                    onClick: function(event) {
                        return handleLightboxDoubleClick(event, index);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                            image: image,
                            height: size === "default" ? 360 : 230,
                            responsive: false,
                            lazyload: true,
                            sizeAttributes: true,
                            trackingStringClick: "".concat(trackingStringPrefix, "_image_preview:click_wrong"),
                            trackingStringDblClick: "".concat(trackingStringPrefix, "_image_preview:double_click")
                        }),
                        showLightbox && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            className: (GallerySlider_module_default()).fullScreenButton,
                            onClick: function(event) {
                                return handleLightboxSingleClick(event, index);
                            },
                            "data-tr-click": "".concat(trackingStringPrefix, "_fullscreen_icon:click"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fullscreen/* default */.Z, {})
                        })
                    ]
                })
            }, index);
            slides.push(slide);
        });
        return slides;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: gallery.images.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderWithDots/* default */.Z, {
                    slides: getSlides(gallery.images),
                    options: sliderOptions,
                    dotsPosition: sliderDotsPosition,
                    autoplay: autoplay,
                    arrows: showArrows,
                    trackingStringPrefix: trackingStringPrefix
                }),
                showLightbox && /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryLightBox/* default */.Z, {
                    images: gallery.images,
                    open: lightboxOpen,
                    currentSlideIndex: lightboxCurrentSlide
                })
            ]
        })
    });
};
/* harmony default export */ var GallerySlider_GallerySlider = (GallerySlider);

;// CONCATENATED MODULE: ./src/components/models/media/GallerySlider/index.ts



/***/ }),

/***/ 53249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TravelGuideTeaser_TravelGuideTeaser; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/models/travelGuide/TravelGuideTeaser/TravelGuideTeaser.module.scss
var TravelGuideTeaser_module = __webpack_require__(85169);
var TravelGuideTeaser_module_default = /*#__PURE__*/__webpack_require__.n(TravelGuideTeaser_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(48648);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(42500);
;// CONCATENATED MODULE: ./src/components/models/travelGuide/TravelGuideTeaser/TravelGuideTeaser.tsx




var TravelGuideTeaser = function(param) {
    var travelGuide = param.travelGuide;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        className: "".concat((TravelGuideTeaser_module_default()).root, " h-100"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                image: travelGuide.image,
                altDefault: "".concat(travelGuide.firstName, " ").concat(travelGuide.lastName),
                aspectRatio: 1.777,
                width: 635,
                responsive: false,
                className: "card-img"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                className: (TravelGuideTeaser_module_default()).cardBody,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                        className: (TravelGuideTeaser_module_default()).cardTitle,
                        children: [
                            travelGuide.firstName,
                            " ",
                            travelGuide.lastName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Text */.Z.Text, {
                        dangerouslySetInnerHTML: {
                            __html: travelGuide.description
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TravelGuideTeaser_TravelGuideTeaser = (TravelGuideTeaser);

;// CONCATENATED MODULE: ./src/components/models/travelGuide/TravelGuideTeaser/index.tsx



/***/ }),

/***/ 54473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBreakpoint; }
/* harmony export */ });
/* unused harmony export breakpoints */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

var breakpoints = [
    {
        name: "uw",
        minWidth: 1930
    },
    {
        name: "fhd",
        minWidth: 1700
    },
    {
        name: "xxl",
        minWidth: 1400
    },
    {
        name: "xl",
        minWidth: 1200
    },
    {
        name: "lg",
        minWidth: 992
    },
    {
        name: "md",
        minWidth: 768
    },
    {
        name: "sm",
        minWidth: 576
    },
    {
        name: "xs",
        minWidth: 0
    }, 
];
function useBreakpoint() {
    var handleResize = function handleResize() {
        if (true) {
            for(var i = 0; i < breakpoints.length; i++){
                if (window.innerWidth >= breakpoints[i].minWidth) {
                    setBreakpoint(breakpoints[i].name);
                    break;
                }
            }
        }
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined), breakpoint = ref[0], setBreakpoint = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // only execute all the code below in client side
        if (true) {
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return function() {
                return window.removeEventListener("resize", handleResize);
            };
        }
    }, []) // Empty array ensures that effect is only run on mount
    ;
    return breakpoint;
}


/***/ }),

/***/ 49077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73974);

var cloudinaryUrlGenerator = new _cloudinary_url_gen__WEBPACK_IMPORTED_MODULE_0__/* .Cloudinary */ .r({
    cloud: {
        cloudName: "skag"
    },
    url: {
        analytics: false
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (cloudinaryUrlGenerator);


/***/ }),

/***/ 61207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TitleDecoration_TitleDecoration; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/styled-jsx@5.0.7_@babel+core@7.29.7_babel-plugin-macros@3.1.0_react@18.2.0/node_modules/styled-jsx/style.js
var style = __webpack_require__(48692);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./src/integrations/cloudinary/helpers.ts
var helpers = __webpack_require__(99224);
;// CONCATENATED MODULE: ./src/themes/carreisen-ostschweiz/components/cms/TitleDecoration/TitleDecoration.tsx



var TitleDecoration = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: style_default().dynamic([
                    [
                        "67f71dce2083f54f",
                        [
                            (0,helpers/* getCloudinaryThemeFileUrl */.k)("images/elements/lines-short.png"),
                            (0,helpers/* getCloudinaryThemeFileUrl */.k)("images/elements/lines.png")
                        ]
                    ]
                ]) + " " + "root ".concat(className)
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "67f71dce2083f54f",
                dynamic: [
                    (0,helpers/* getCloudinaryThemeFileUrl */.k)("images/elements/lines-short.png"),
                    (0,helpers/* getCloudinaryThemeFileUrl */.k)("images/elements/lines.png")
                ],
                children: ".root.__jsx-style-dynamic-selector{background-image:url(".concat((0,helpers/* getCloudinaryThemeFileUrl */.k)("images/elements/lines-short.png"), ");height:55px;background-repeat:no-repeat;-webkit-background-size:80%60px;-moz-background-size:80%60px;-o-background-size:80%60px;background-size:80%60px;background-position:right;position:absolute;width:100%;top:14px;right:-8px;@media(min-width:768px){background-image:url(").concat((0,helpers/* getCloudinaryThemeFileUrl */.k)("images/elements/lines.png"), ");-webkit-background-size:60%60px;-moz-background-size:60%60px;-o-background-size:60%60px;background-size:60%60px}}")
            })
        ]
    });
};
/* harmony default export */ var TitleDecoration_TitleDecoration = (TitleDecoration);

;// CONCATENATED MODULE: ./src/themes/carreisen-ostschweiz/components/cms/TitleDecoration/index.tsx



/***/ }),

/***/ 16128:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Title_root__wBnqm","withDecoration":"Title_withDecoration__s2B4T","visible":"Title_visible__Of66j","positioner":"Title_positioner__aMY_s","subTitle":"Title_subTitle__BlY7p"};

/***/ }),

/***/ 96665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Accordion_root__ayn4U","accordionHeader":"Accordion_accordionHeader__0sObz","collapsed":"Accordion_collapsed__lRo2C","accordionItem":"Accordion_accordionItem__FtqYE","unstyledWhite":"Accordion_unstyledWhite__sGbKI","accordion":"Accordion_accordion__tNHwr","accordionButton":"Accordion_accordionButton__bEs_O","active":"Accordion_active__0TI1W","cardBody":"Accordion_cardBody__Pl06_"};

/***/ }),

/***/ 97227:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageGradientOverlay_root__dRvm9","top":"ImageGradientOverlay_top__VCJX6","bottom":"ImageGradientOverlay_bottom__8rXGh"};

/***/ }),

/***/ 47464:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"CloudinaryImage_placeholder__kWdxK"};

/***/ }),

/***/ 86539:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ResponsiveHeaderImage_root__WMHbf"};

/***/ }),

/***/ 61216:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"embla":"EmblaCarousel_embla__u_yvS","embla__viewport":"EmblaCarousel_embla__viewport__NVlVg","is-draggable":"EmblaCarousel_is-draggable__YNUor","is-dragging":"EmblaCarousel_is-dragging__UG3fs","embla__container":"EmblaCarousel_embla__container__UiXwS","embla__buttons":"EmblaCarousel_embla__buttons__VF7Zk","embla__dots":"EmblaCarousel_embla__dots___SVdS","bottom":"EmblaCarousel_bottom__fC8af","below":"EmblaCarousel_below__WvfYE"};

/***/ }),

/***/ 88555:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"embla__button":"DotButton_embla__button__Bseqb","embla__button__svg":"DotButton_embla__button__svg__AU6dh","embla__button--prev":"DotButton_embla__button--prev__avooL","embla__button--next":"DotButton_embla__button--next__OzmW1","embla__dot":"DotButton_embla__dot__lwMwj","light":"DotButton_light__TIWmF","dark":"DotButton_dark__JGQ_c","isSelected":"DotButton_isSelected__NN71F"};

/***/ }),

/***/ 50500:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"embla__button":"NextButton_embla__button__ZdRxW","embla__button__svg":"NextButton_embla__button__svg__wtbe2","embla__buttonPrev":"NextButton_embla__buttonPrev__OtiYA","embla__buttonNext":"NextButton_embla__buttonNext__kPNAW"};

/***/ }),

/***/ 61148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"embla__button":"PrevButton_embla__button__t0_kI","embla__button__svg":"PrevButton_embla__button__svg__Njytk","embla__buttonPrev":"PrevButton_embla__buttonPrev__rg9pR","embla__buttonNext":"PrevButton_embla__buttonNext__LkvwB"};

/***/ }),

/***/ 82411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TextWithIconBlock_root__ZTPDK","content":"TextWithIconBlock_content__csk7K","cardTitle":"TextWithIconBlock_cardTitle__zHPXg","iconWrap":"TextWithIconBlock_iconWrap__V2snd"};

/***/ }),

/***/ 56513:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TextWithImageSlider_root__VE0M_","embla":"TextWithImageSlider_embla__xnZih","embla__container":"TextWithImageSlider_embla__container__y_u75","embla__slide":"TextWithImageSlider_embla__slide__xMr_c","img":"TextWithImageSlider_img__gOTzq","wide":"TextWithImageSlider_wide__NSkLt","embla__dots":"TextWithImageSlider_embla__dots__a89qP","bottom":"TextWithImageSlider_bottom__LGyXW","below":"TextWithImageSlider_below__dLaAx"};

/***/ }),

/***/ 13333:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slideWrap":"GallerySlider_slideWrap__rftwT","slideInner":"GallerySlider_slideInner__a3aq1","slideInnerSmall":"GallerySlider_slideInnerSmall__84ilK","fullScreenButton":"GallerySlider_fullScreenButton__o_XuT"};

/***/ }),

/***/ 85169:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelGuideTeaser_root__pF2SJ","cardBody":"TravelGuideTeaser_cardBody__GllVo","cardTitle":"TravelGuideTeaser_cardTitle__1fEM1"};

/***/ }),

/***/ 7146:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomButton_root___glip","ribbon":"CustomButton_ribbon__JNwqX"};

/***/ })

}]);